/**
 * Compatibility API for predictive search with recently viewed products disabled.
 */
export class RecentlyViewed {
  static clearProducts() {}

  /**
   * Keeps the generic predictive-search integration operational without storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return [];
  }
}
